import { createReducer, on, Action } from '@ngrx/store';
import { OfferState } from './offers.state';
import * as offersActions from '@store/offers/offers.actions';

export const initialOffer: OfferState = {
  offers: null,
  previewOffers: null,
  amount: null,
  offersId: [],
  isLoading: false,
  previewOffer: null,
  offerQuantity: null,
  offerId: null,
  numberOfInstallments: 0,
};

const _offerReducer = createReducer(
  initialOffer,
  // Offers by Merchant
  on(offersActions.getOffersByMerchant, (state) => {
    return {
      ...state,
      isLoading: true,
      error: false,
    };
  }),
  on(offersActions.successGetOffersByMerchant, (state, { offers }) => {
    return {
      ...state,
      offers,
      error: false,
    };
  }),
  on(offersActions.failureGetOffersByMerchant, (state) => {
    return {
      ...state,
      isLoading: false,
      error: true,
    };
  }),
  on(offersActions.setOfferAmount, (state, { amount }) => {
    return {
      ...state,
      amount,
    };
  }),
  // Offer Preview
  on(offersActions.getOfferPreview, (state) => {
    return {
      ...state,
      isLoading: true,
      error: false,
    };
  }),
  on(offersActions.getOneOfferPreview, (state) => {
    return {
      ...state,
      isLoading: true,
      error: false,
    };
  }),
  on(offersActions.successOneOfferPreview, (state, { previewOffer }) => {
    return {
      ...state,
      previewOffer,
      isLoading: false,
      error: false,
    };
  }),
  on(offersActions.failureOneOfferPreview, (state) => {
    return {
      ...state,
      isLoading: false,
      error: true,
    };
  }),
  on(offersActions.successGetOfferPreview, (state, { previewOffers }) => {
    return {
      ...state,
      previewOffers,
      isLoading: false,
      error: false,
    };
  }),
  on(offersActions.failureGetOfferPreview, (state) => {
    return {
      ...state,
      isLoading: false,
      error: true,
    };
  }),
  on(offersActions.setPreviewOffer, (state, { previewOffer }) => {
    return {
      ...state,
      previewOffer,
    };
  }),
  on(offersActions.setSelectedOfferId, (state, { offerId }) => {
    return {
      ...state,
      offerId,
    };
  }),
  on(offersActions.setOfferLoading, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  }),
  on(offersActions.setNumberOfInstallments, (state, { numberOfInstallments }) => {
    return {
      ...state,
      numberOfInstallments,
    };
  })
);

export function offerReducers(state: OfferState | undefined, action: Action) {
  return _offerReducer(state, action);
}
